module.exports = __webpack_public_path__ + "img/alert-modal.533862a2.svg";